module.exports = __webpack_public_path__ + "img/6.ab9536e6.jpg";